export const enum ErrorTypeEnum {
  NOT_FOUND = 'NotFound',
  SERVER_ERROR = 'ServerError',
  UNAUTHORIZED = 'Unauthorized',
}

export const enum PanelTypeEnum {
  ERROR_PANEL = 'errorPanel',
  INFO_PANEL = 'infoPanel',
  FEEDBACK = 'feedback',
}
